/* eslint-disable no-param-reassign */
/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useCallback, useEffect, useState } from 'react';
import { withRouter } from 'react-router';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import { Button, Tooltip } from 'react-bootstrap';
import TextField from '@material-ui/core/TextField';
import { useDispatch, useSelector } from 'react-redux';
import MenuItem from '@material-ui/core/MenuItem';
import _ from 'lodash';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import { manuFactureHead } from './gridComponents/tableHead';
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';

import {
  searchInvoiceByPQR,
  getInvoiceDetailsByInvoiceNum,
  searchInvoiceRequestAction,
  setSelectedClient,
  setInvoiceNumber,
  getMaxQuarterForFreezeDt,
  setErrorMessagesData,
  setSaveRequest,
  setInvoiceQtr,
  setDisplayInvoiceObj,
  setMfgSelected,
  setInvoiceOtherQtrIndex,
  dispatchInvoiceQuarterTotals,
  setInvoiceOtherHideZeroBalance,
  setNoRecordFound,
} from '../store/actions';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import * as CONSTANTS from '../../../../SharedModules/AppConstants';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import {
  checkQuarterValidation,
  formatQuater,
  quarterFormatter,
  validateQuarter,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import {
  navigateToNextCell,
  onCellFocused,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import ViewHistoryComponent from '../../../../SharedModules/MicroFrontend/ViewHistoryComponent';
import { getRebateProgramDropdownList } from '../../../Research/UnderThresholdInvoices/store/Actions';
import { autoFormateDate } from '../../../../SharedModules/utilities/utilities';

function RequestInvoiceDetails(props) {
  const dispatch = useDispatch();

  const selectedClient = useSelector(
    (state) => state.sharedState.DisplayInvoiceReducer.selectedClient
  );
  const searchInvoiceRequest = useSelector(
    (state) => state.sharedState.DisplayInvoiceReducer.searchInvoiceRequest
  );
  const invoiceNumber = useSelector(
    (state) => state.sharedState.DisplayInvoiceReducer.invoiceNumber
  );
  const UserDefaultValues = useSelector(
    (state) => state.sharedState.UserDefaultReducer.UserDefaultsValues.data
  );
  localStorage.setItem('UserDefaultValues', JSON.stringify(UserDefaultValues));
  const invoiceData = useSelector(
    (state) => state.sharedState.DisplayInvoiceReducer.invoiceDetailsByPQR
  );
  const invoiceDetailsByInvoiceNum = useSelector(
    (state) =>
      state.sharedState.DisplayInvoiceReducer.invoiceDetailsByInvoiceNum
  );
  const noRecordFound = useSelector(
    (state) => state.sharedState.DisplayInvoiceReducer.noRecordFound
  );
  const invoiceSearchCount = useSelector(
    (state) => state.sharedState.DisplayInvoiceReducer.invoiceSearchCount
  );
  const searchClicked = useSelector(
    (state) => state.sharedState.DisplayInvoiceReducer.searchClicked
  );
  const defaultQtr = useSelector(
    (state) => state?.sharedState?.DisplayInvoiceReducer?.defaultQtr?.data
  );
  const errorMessagesData = useSelector(
    (state) => state?.sharedState?.DisplayInvoiceReducer?.errorMessages
  );
  const invoiceQtr = useSelector(
    (state) => state?.sharedState?.DisplayInvoiceReducer?.invoiceQtr
  );
  const defaultPlanType = useSelector(
    (state) =>
      state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
        ?.planTypeCd
  );
  const defaultRebateCd = useSelector(
    (state) =>
      state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
        ?.rebateProgramCd
  );
  const mfgSelected = useSelector(
    (state) => state.sharedState?.DisplayInvoiceReducer.mfgSelected
  );
  const [redirect, setRedirect] = useState(false);
  const [errorMessages, setErrorMessages] = useState([]);
  const [fullScreenView, setFullScreenView] = useState(false);
  const [spinnerLoader, setspinnerLoader] = useState(false);
  const [keyValue, setKeyValue] = useState([]);
  const [showViewHistory, setShowViewHistory] = useState(false);
  const [quarter, setQuarter] = useState('');
  const [selectedBy, setSelectedBy] = useState(UserDefaultValues?.defInvoiceSelectModeCd||'PQM');
  const [selectManufacturer, setSelectManufacturer] = useState(
    mfgSelected || {}
  );
  const pendingInvoiceNumRef = React.useRef(null);
  const lastInvoiceSearchCountRef = React.useRef(null);
  const [invError, setInvError] = React.useState(false);

  const handleErrorMessages = (messages) => {
    setErrorMessages(messages);
    dispatch(setErrorMessagesData(messages));
  };

  const showInvoiceNotFoundError = (invNumber) => {
    handleErrorMessages([
      `${CONSTANTS.INVOICE_NOT_FOUND}. Invoice: #${invNumber}`,
    ]);
    setInvError(true);
    setRedirect(false);
  };

  const isNoRecordInvoiceResponse = (response) => {
    if (response == null || response === '') return true;
    if (response?._noRecord) return true;
    const data = response?.data ?? response;
    if (typeof data === 'string') {
      const lower = data.toLowerCase();
      return lower.includes('no record') || lower.includes('not found');
    }
    return false;
  };

  useEffect(() => {
    dispatch(getMaxQuarterForFreezeDt());
    setRedirect(false);
    dispatch(setInvoiceNumber(''));
    dispatch(setNoRecordFound(false));
    handleErrorMessages([]);
  }, []);
  React.useEffect(()=>{
if(!initialFetchDoneRef.current && searchInvoiceRequest?.quarter){
      initialFetchDoneRef.current = true;
      if (selectedClient !== 'IN') {
        handleInvoiceSearchClick({ showNoRecordError: false })
      }
    }
  },[searchInvoiceRequest])

  // handling refresh functionality
  useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    const newObj =
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.map((item) => {
        if (item.navTo === '/request-invoice-detail') {
          if (errorMessages?.length > 0) {
            item.isFormError = true;
          } else {
            item.isFormError = false;
          }
        }
        return item;
      });
    localStorage.setItem('tabItemsData', JSON.stringify(newObj));
  }, [errorMessages]);

  useEffect(() => {
    setspinnerLoader(false);
  }, [invoiceData]);

  useEffect(() => {
    if (invoiceQtr) {
      setQuarter(invoiceQtr);
    } else {
      setQuarter(defaultQtr);
      if (!searchInvoiceRequest?.saveButtonEnable) {
        dispatch(
          searchInvoiceRequestAction({
            ...searchInvoiceRequest,
            saveButtonEnable: false,
            quarter: defaultQtr,
          })
        );
      }
    }
  }, [invoiceQtr, defaultQtr]);

  const goToInvoiceDetails = (invoiceData) => {
    setRedirect(false);
    pendingInvoiceNumRef.current = null;
    setspinnerLoader(false);
    handleErrorMessages([]);
    dispatch(setNoRecordFound(false));
    dispatch(setInvoiceOtherHideZeroBalance(true));
    const storedTabs = JSON.parse(localStorage.getItem('tabItemsData')) || [];
    const hasDetailsTab = storedTabs.some(
      (item) => item.navTo === '/display-invoice'
    );
    if (!hasDetailsTab) {
      storedTabs.push({
        navTo: '/display-invoice',
        value: 'Display Invoice',
      });
      localStorage.setItem('tabItemsData', JSON.stringify(storedTabs));
    }
    dispatch(setInvoiceOtherQtrIndex(0));
    dispatch(dispatchInvoiceQuarterTotals([]));
    props.history.push({
      pathname: '/display-invoice',
      invoiceDetailsByInvoiceNum: invoiceData,
    });
  };

useEffect(() => {
  const isNewSearchResult =
    lastInvoiceSearchCountRef.current !== null &&
    lastInvoiceSearchCountRef.current !== invoiceSearchCount;
  lastInvoiceSearchCountRef.current = invoiceSearchCount;

  const requestedNum = pendingInvoiceNumRef.current;
  const returnedNum = invoiceDetailsByInvoiceNum?.data?.invoiceNum;
  if (noRecordFound && isNewSearchResult) {
    showInvoiceNotFoundError(requestedNum || invoiceNumber);
    return;
  }
  if (
    isNewSearchResult &&
    redirect &&
    requestedNum != null &&
    returnedNum != null &&
    String(returnedNum) === String(requestedNum) &&
    invoiceDetailsByInvoiceNum?.data &&
    typeof invoiceDetailsByInvoiceNum.data !== 'string' &&
    !invoiceDetailsByInvoiceNum._noRecord &&
    !invoiceDetailsByInvoiceNum._stale
  ) {
    goToInvoiceDetails(invoiceDetailsByInvoiceNum.data);
  }
}, [invoiceDetailsByInvoiceNum, noRecordFound, redirect, searchClicked, invoiceSearchCount]);

  const [rbtErr, setRbtErr] = React.useState(false);
  const [qtrErr, setQtrErr] = React.useState(false);
  const [rebateProgramList, setRebateProgramList] = React.useState([]);
  const initialFetchDoneRef = React.useRef(false);

  const handleInvoiceSearch = (e) => {
    if (e?.target?.name === 'quarter') {
      setQuarter('');
    }
    let updatedSearchRequest = {
      ...searchInvoiceRequest,
      [e.target.name]: e.target.value,
    };

    if ('planType' in searchInvoiceRequest && e.target.name === 'planType') {
      updatedSearchRequest = {
        ...updatedSearchRequest,
        rebateProgramCode: '-1',
        shortDescr: '', // Reset shortDescr when changing planType
      };
    } else if (e.target.name === 'rebateProgramCode') {
      const selectedRebateProgram = rebateProgramList.find(
        (item) => item.rebateProgramCd === e.target.value
      );
      if (selectedRebateProgram && selectedRebateProgram != -1) {
        updatedSearchRequest.shortDescr = selectedRebateProgram.shortDescr;
        setRbtErr(false);
      } else {
        setRbtErr(true);
        handleErrorMessages([...errorMessages, 'Rebate Program is required.']);
      }
    }

    dispatch(searchInvoiceRequestAction(updatedSearchRequest));
  };

  const handleInvoiceNumber = (e) => {
    dispatch(setInvoiceNumber(e.target.value));
    if (e.target.value) setInvError(false);
    else setInvError(true);
  };

  const validateInvoicePQRRequest = () => {
    const errorMessage = [];
    if (!searchInvoiceRequest?.quarter && !quarter) {
      setQtrErr(constantMessageData.QUARTER_VALUE_REQUIRED);
      errorMessage.push(constantMessageData.QUARTER_VALUE_REQUIRED);
    }

    if (
      searchInvoiceRequest?.quarter !== '' &&
      !quarterFormatter(searchInvoiceRequest?.quarter)
    ) {
      setQtrErr(CONSTANTS.QUARTER_FORMAT_ERROR);
      errorMessage.push(CONSTANTS.QUARTER_FORMAT_ERROR);
    }
    if (
      !searchInvoiceRequest?.rebateProgramCode === '' ||
      searchInvoiceRequest?.rebateProgramCode === null ||
      searchInvoiceRequest?.rebateProgramCode === '-1' 
    ) {
      errorMessage.push('Rebate Program is required.');
    }
    if (
      searchInvoiceRequest?.planType === '' ||
      searchInvoiceRequest?.planType === null
    ) {
      errorMessage.push('Plan Type is required.');
    }

    if (errorMessage.length > 0) {
      handleErrorMessages(errorMessage);
      return false;
    }
    handleErrorMessages([]);
    return true;
  };

  const handleInvoiceSearchClick = ({ showNoRecordError = true } = {}) => {
    if (validateInvoicePQRRequest()) {
      let searchInvoiceRequestPayload = { ...searchInvoiceRequest };
      if (
        (searchInvoiceRequest?.quarter !== null ||
          searchInvoiceRequest?.quarter !== '') &&
        quarterFormatter(searchInvoiceRequest?.quarter) &&
        searchInvoiceRequest?.quarter?.split('Q')?.[1]?.length === 2
      ) {
        searchInvoiceRequestPayload = {
          ...searchInvoiceRequest,
          quarter: `${
            searchInvoiceRequest?.quarter?.split('Q')?.[0]
          }Q${new Date().getFullYear().toString().substr(0, 2)}${
            searchInvoiceRequest?.quarter?.split('Q')?.[1]
          }`,
        };
      } else if (!searchInvoiceRequest?.quarter) {
        searchInvoiceRequestPayload.quarter = quarter;
      } else if(!searchInvoiceRequestPayload?.rebateProgramCode||!searchInvoiceRequestPayload?.planType){
        searchInvoiceRequestPayload.rebateProgramCode = searchInvoiceRequest?.rebateProgramCode  || UserDefaultValues?.rebateProgramCd
        searchInvoiceRequestPayload.shortDescr=''
        searchInvoiceRequestPayload.planType = searchInvoiceRequest?.planType || UserDefaultValues?.planTypeCd
        searchInvoiceRequestPayload.page = '0'
        searchInvoiceRequestPayload.pageSize = '100'
        }
      setspinnerLoader(true);
      dispatch(setNoRecordFound(false));
      dispatch(searchInvoiceByPQR(searchInvoiceRequestPayload)).then((result) => {
        setspinnerLoader(false);
        if (showNoRecordError && result?.isNoRecord) {
          handleErrorMessages([CONSTANTS.NO_RECORDS_FOUND]);
        }
      });
      dispatch(setSaveRequest({}));
      dispatch(setInvoiceNumber(''));
    }
  };

  const isNumber = (evt) => {
    evt = evt || window.event;
    const charCode = evt.which ? evt.which : evt.keyCode;
    if ((charCode !== 8 && charCode !== 0 && charCode < 48) || charCode > 57) {
      evt.preventDefault();
      // handleErrorMessages(['Invalid Invoice Number']);
      return false;
    }
    handleErrorMessages([]);
    return true;
  };

  const handleSearchByInvoiceNumber = async () => {
    const errorMessage = [];
    if (invoiceNumber) {
      setspinnerLoader(true);
      setRedirect(false);
      pendingInvoiceNumRef.current = invoiceNumber;
      dispatch(setNoRecordFound(false));
      handleErrorMessages([]);
      dispatch(
        setDisplayInvoiceObj({
          tabValue: 0,
        })
      );
      dispatch(setSaveRequest({}));
      dispatch(setInvoiceQtr(''));
      dispatch(
        searchInvoiceRequestAction({
          ...searchInvoiceRequest,
          planType: defaultPlanType,
          rebateProgramCode: defaultRebateCd,
        })
      );
      try {
        const response = await dispatch(
          getInvoiceDetailsByInvoiceNum({ invoiceNum: invoiceNumber })
        );
        if (
          String(pendingInvoiceNumRef.current) !== String(invoiceNumber) ||
          response?._stale
        ) {
          setspinnerLoader(false);
          return;
        }
        const responseData = response?.data;
        if (
          isNoRecordInvoiceResponse(response) ||
          !responseData ||
          typeof responseData === 'string' ||
          responseData?.invoiceNum == null ||
          String(responseData.invoiceNum) !== String(invoiceNumber)
        ) {
          showInvoiceNotFoundError(invoiceNumber);
          setspinnerLoader(false);
          return;
        }
        goToInvoiceDetails(responseData);
      } catch (error) {
        showInvoiceNotFoundError(invoiceNumber);
        setspinnerLoader(false);
      }
    } else {
      setInvError(true);
      errorMessage.push('Invoice Number is required.');
      handleErrorMessages(errorMessage);
    }
  };

  const selectByInvoiceNumberClick = async (e) => {
    const requestedNum = e.data.invoiveNum;
    pendingInvoiceNumRef.current = requestedNum;
    setRedirect(true);
    setspinnerLoader(true);
    handleErrorMessages([]);
    dispatch(setNoRecordFound(false));
    dispatch(
      setDisplayInvoiceObj({
        tabValue: 0,
      })
    );
    dispatch(setSaveRequest({}));
    try {
      const response = await dispatch(
        getInvoiceDetailsByInvoiceNum({ invoiceNum: requestedNum })
      );
      if (
        String(pendingInvoiceNumRef.current) !== String(requestedNum) ||
        response?._stale
      ) {
        setspinnerLoader(false);
        return;
      }
      const responseData = response?.data;
      if (
        isNoRecordInvoiceResponse(response) ||
        !responseData ||
        typeof responseData === 'string'
      ) {
        showInvoiceNotFoundError(requestedNum);
        setspinnerLoader(false);
        return;
      }
      if (
        responseData?.invoiceNum != null &&
        String(responseData.invoiceNum) !== String(requestedNum)
      ) {
        showInvoiceNotFoundError(requestedNum);
        setspinnerLoader(false);
        return;
      }
      goToInvoiceDetails(responseData);
    } catch (error) {
      showInvoiceNotFoundError(requestedNum);
      setspinnerLoader(false);
    }
  };

  // set common dropdown list after calling API service
  React.useEffect(() => {
    if (searchInvoiceRequest.planType||UserDefaultValues?.planTypeCd) {
      if(!searchInvoiceRequest?.rebateProgramCode && searchInvoiceRequest?.quarter){
        dispatch(
          searchInvoiceRequestAction({
            ...searchInvoiceRequest,
            rebateProgramCode:"-1"
          })
        );
      }
      getRebateProgramDropdownList(searchInvoiceRequest.planType||UserDefaultValues?.planTypeCd).then(
        (res) => {
          let list = [];
          if (
            res?.status === constantMessageData.STATUS_MSG &&
            res?.message === constantMessageData.SUCCESS_MSG
          ) {
            if (!_.isEmpty(res.data)) {
              list = _.map(res.data, (val) => ({
                ...val,
                id: val.rebateProgramCd,
                name: `${val.rebateProgramCd} | ${val.shortDescr}`,
              }));
            }
          }
          setRebateProgramList(
            list.sort((key, val) =>
              key.name.toLowerCase().localeCompare(val.name.toLowerCase())
            )
          );
        }
      );
    }
  }, [searchInvoiceRequest.planType,UserDefaultValues?.planTypeCd]);

  useEffect(() => {
    if (selectedClient) {
      setSelectedBy(selectedClient);
    }
  }, [selectedClient]);

  const handleFullScreenViewClick = () => {
    setFullScreenView(!fullScreenView);
  };

  const handleSelectedClient = useCallback(
    (client) => {
      dispatch(setSelectedClient(client));
      handleErrorMessages([]);
    },
    [selectedClient]
  );
  const handleOnblurEvent = (name, value) => {
    let errorMessage = [...errorMessagesData];
    if (!value) {
      setQtrErr(constantMessageData.QUARTER_VALUE_REQUIRED);
      errorMessage = errorMessage?.filter((x) => {
        return !x.includes(constantMessageData.REQUEST_DATE_INVALID_FORMAT_CBI);
      });
      errorMessage.push(constantMessageData.QUARTER_VALUE_REQUIRED);
    } else if (!checkQuarterValidation(value)) {
      errorMessage = errorMessage?.filter((x) => {
        return !x.includes(constantMessageData.QUARTER_VALUE_REQUIRED);
      });
      errorMessage.push(constantMessageData.REQUEST_DATE_INVALID_FORMAT_CBI);
      setQtrErr(constantMessageData.REQUEST_DATE_INVALID_FORMAT_CBI);
    } else {
      errorMessage = errorMessage?.filter((x) => {
        return (
          !x.includes(constantMessageData.REQUEST_DATE_INVALID_FORMAT_CBI) &&
          !x.includes(constantMessageData.QUARTER_VALUE_REQUIRED)
        );
      });
      setQtrErr('');
    }
    dispatch(
      searchInvoiceRequestAction({
        ...searchInvoiceRequest,
        quarter: autoFormateDate(value?.toUpperCase()),
        saveButtonEnable: true,
      })
    );
    handleErrorMessages(errorMessage);
  };
const [gridApi, setGridApi] = useState(null);

  // handing by default row selection function
const onGridReady = (params) => {
    setGridApi(params.api);
  if (!invoiceData || invoiceData.length === 0) return;
  let selectedNode = null;
  if (mfgSelected?.manufacturerId) {
    params.api.forEachNode((node) => {
      if (node.data?.manufacturerId === mfgSelected.manufacturerId) {
        node.setSelected(true);
        selectedNode = node;
      }
    });
  }
  if (!selectedNode) {
    const firstNode = params.api.getDisplayedRowAtIndex(0);
    if (firstNode) {
      firstNode.setSelected(true);
      selectedNode = firstNode;
    }
  }
  if (selectedNode) {
    onSelectManufacturer(selectedNode);
  }
};

useEffect(() => {
  if (!gridApi || !invoiceData || invoiceData.length === 0) return;

  let selectedNode = null;

  if (mfgSelected?.manufacturerId) {
    gridApi.forEachNode((node) => {
      if (node.data?.manufacturerId === mfgSelected.manufacturerId) {
        node.setSelected(true);
        selectedNode = node;
      }
    });
  }

  if (!selectedNode) {
    const firstNode = gridApi.getDisplayedRowAtIndex(0);
    if (firstNode) {
      firstNode.setSelected(true);
      selectedNode = firstNode;
    }
  }

  if (selectedNode) {
    onSelectManufacturer(selectedNode);
  }
}, [gridApi, invoiceData]);



  const onSelectManufacturer = React.useCallback((e) => {
    setSelectManufacturer(e.data);
    dispatch(setMfgSelected(e.data));
  });

  return (
    <div className='tBillPanel custom-check'>
      <div className='panel tBillPanel-space devider-line pb-0'>
        {spinnerLoader && <Spinner load={spinnerLoader} />}
        <CustomSeparator parent1='Display' parent2='Invoice Details' />
        {!fullScreenView && (
          <>
            <DisplayErrorMessages errorMessages={[...new Set(errorMessages)]} />
            <div className='no-margin'>
              <div className='row mb-2'>
                <div
                  className={`col-12 col-sm-12 ${
                    selectedBy !== 'IN'
                      ? 'col-md-7 col-lg-7'
                      : 'col-md-8 col-lg-8'
                  }`}
                >
                  <fieldset className='custom-fieldset'>
                    <legend className='same-font-family' id='selected_by_label'>
                      Selected By <span className='mandatory'> *</span>
                    </legend>
                    <div className='form-wrapper p-0 mt-2'>
                      <div className='mui-custom-form input-md field-xl'>
                        <div className='sub-radio no-margin'>
                          <FormControl>
                            <RadioGroup
                              row
                              aria-labelledby='selected_by_label'
                              name='row-radio-buttons-group'
                              defaultValue={selectedBy || 'PQM'}
                              value={selectedBy || 'PQM'}
                            >
                              <FormControlLabel
                                style={{ marginRight: '0px' }}
                                value='PQM'
                                control={
                                  <Radio
                                    onChange={() => {
                                      handleSelectedClient('PQM');
                                    }}
                                  />
                                }
                                label='Program, Quarter, Manufacturer'
                                data-test='PQM'
                              />
                              <FormControlLabel
                                style={{ marginLeft: '5%' }}
                                value='IN'
                                control={
                                  <Radio
                                    onChange={() => {
                                      handleSelectedClient('IN');
                                    }}
                                  />
                                }
                                label='Invoice Number'
                                data-test='IN'
                              />
                            </RadioGroup>
                          </FormControl>
                        </div>
                      </div>
                    </div>
                  </fieldset>
                </div>

                <div
                  className={`col-12 col-sm-12  ${
                    selectedBy !== 'IN'
                      ? 'col-md-5 col-lg-5'
                      : 'col-md-4 col-lg-4 mt-2'
                  }  frr-radio-40per-width`}
                >
                  {selectedBy !== 'IN' && (
                    <fieldset className='custom-fieldset'>
                      <legend className='same-font-family' id='plan_type_label'>
                        Plan Type <span className='mandatory'> *</span>
                      </legend>
                      <div className='form-wrapper p-0 mt-2'>
                        <div className='mui-custom-form input-md field-xl'>
                          <div className='sub-radio no-margin'>
                            <FormControl>
                              <RadioGroup
                                row
                                aria-labelledby='plan_type_label'
                                name='planType'
                                value={searchInvoiceRequest.planType || UserDefaultValues?.planTypeCd}
                                onChange={handleInvoiceSearch}
                              >
                                <FormControlLabel
                                  value='FD'
                                  control={<Radio />}
                                  label='Medicaid'
                                  data-test='Medicaid'
                                />
                                <FormControlLabel
                                  value='COMM'
                                  control={<Radio />}
                                  label='Commercial'
                                  data-test='Commercial'
                                />
                                <FormControlLabel
                                  value='ST'
                                  control={<Radio />}
                                  label='State'
                                  data-test='State'
                                />
                                <FormControlLabel
                                  value='SUPP'
                                  control={<Radio />}
                                  label='Supplemental'
                                  data-test='Supplemental'
                                />
                              </RadioGroup>
                            </FormControl>
                          </div>
                        </div>
                      </div>
                    </fieldset>
                  )}
                  {selectedBy === 'IN' && (
                    <fieldset className='custom-fieldset'>
                      <legend aria-hidden='true' className='d-none' />
                      <div className='row'>
                        <div className='col-12'>
                          <div className='mui-custom-form with-select'>
                            <TextField
                              fullWidth
                              required
                              label='Invoice Number'
                              autoComplete='off'
                              id='display-invoice-number'
                              placeholder=''
                              value={invoiceNumber}
                              onChange={handleInvoiceNumber}
                              onKeyPress={isNumber}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              inputProps={{
                                maxLength: 38,
                                'aria-labelledby': 'invoice_number_label',
                              }}
                              className={
                                errorMessages?.length > 0
                                  ? errorMessages?.filter((x) => {
                                      return x.includes('Invoice Number is');
                                    })?.length > 0
                                    ? 'mandate-fields'
                                    : null
                                  : null
                              }
                              error={[
                                ...new Set(
                                  errorMessages
                                    ?.filter((x) => {
                                      return x.includes('Invoice Number is');
                                    })
                                    ?.map((item) => {
                                      return item;
                                    })
                                ),
                              ]}
                              helperText={[
                                ...new Set(
                                  errorMessages
                                    ?.filter((x) => {
                                      return x.includes('Invoice Number is');
                                    })
                                    ?.map((item) => {
                                      return item;
                                    })
                                ),
                              ]}
                            />
                          </div>
                        </div>
                      </div>
                    </fieldset>
                  )}
                </div>
              </div>
              {!fullScreenView && selectedBy !== 'IN' && (
                <div className='row mb-2'>
                  <div className='col-12'>
                    <fieldset className='custom-fieldset'>
                      <legend aria-hidden='true' className='d-none' />
                      <div className='form-wrapper my-2'>
                        <div className='mui-custom-form with-select'>
                          <TextField
                            fullWidth
                            select
                            placeholder=''
                            required
                            id='rebate_program_code_label'
                            label='Rebate Program'
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{
                              id: 'rebate_program_code_label',
                            }}
                            name='rebateProgramCode'
                            value={
                              searchInvoiceRequest.rebateProgramCode ||
                              defaultRebateCd
                            }
                            className={
                              errorMessages?.length > 0
                                ? errorMessages?.filter((x) => {
                                    return x.includes(
                                      'Rebate Program is required'
                                    );
                                  })?.length > 0
                                  ? 'mandate-fields'
                                  : null
                                : null
                            }
                            error={[
                              ...new Set(
                                errorMessages
                                  ?.filter((x) => {
                                    return x.includes(
                                      'Rebate Program is required'
                                    );
                                  })
                                  ?.map((item) => {
                                    return item;
                                  })
                              ),
                            ]}
                            helperText={[
                              ...new Set(
                                errorMessages
                                  ?.filter((x) => {
                                    return x.includes(
                                      'Rebate Program is required'
                                    );
                                  })
                                  ?.map((item) => {
                                    return item;
                                  })
                              ),
                            ]}
                            onChange={handleInvoiceSearch}
                          >
                            <MenuItem
                              selected
                              key='Please Select One'
                              value='-1'
                              className='frr-dropdown-blank-item'
                            />
                            {rebateProgramList?.length > 0
                              ? _.sortBy(rebateProgramList).map((item) => {
                                  return (
                                    <MenuItem
                                      key={item.rebateProgramCd}
                                      value={item.rebateProgramCd}
                                    >
                                      {item.rebateProgramCd} {'|'}{' '}
                                      {item.shortDescr}
                                    </MenuItem>
                                  );
                                })
                              : null}
                          </TextField>
                        </div>
                        <div className='mui-custom-form input-md'>
                          <TextField
                            fullWidth
                            required
                            placeholder=''
                            name='quarter'
                            id='quarter_label'
                            label='Quarter'
                            value={searchInvoiceRequest?.quarter}
                            onChange={handleInvoiceSearch}
                            onBlur={(e) =>
                              handleOnblurEvent('quarter', e.target.value)
                            }
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{
                              maxLength: 6,
                              id: 'quarter_label',
                            }}
                            className={
                              errorMessages?.length > 0
                                ? errorMessages?.filter((x) => {
                                    return (
                                      x.includes('Quarter is required') ||
                                      x.includes(
                                        'Please enter a valid quarter and year in'
                                      )
                                    );
                                  })?.length > 0
                                  ? 'mandate-fields'
                                  : null
                                : null
                            }
                            error={[
                              ...new Set(
                                errorMessages
                                  ?.filter((x) => {
                                    return (
                                      x.includes('Quarter is required') ||
                                      x.includes(
                                        'Please enter a valid quarter and year in'
                                      )
                                    );
                                  })
                                  ?.map((item) => {
                                    return item;
                                  })
                              ),
                            ]}
                            helperText={[
                              ...new Set(
                                errorMessages
                                  ?.filter((x) => {
                                    return (
                                      x.includes('Quarter is required') ||
                                      x.includes(
                                        'Please enter a valid quarter and year in'
                                      )
                                    );
                                  })
                                  ?.map((item) => {
                                    return item;
                                  })
                              ),
                            ]}
                          />
                        </div>
                        <div className='mui-custom-form input-md '>
                          <Button
                            className='btn btn-success btn-search mt-20'
                            style={{ marginTop: '20px' }}
                            onClick={() => handleInvoiceSearchClick()}
                            data-testid='check_search_cbi'
                          >
                            <SVGComponent iconName='Icon-search' /> {'  '}
                            Search
                          </Button>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                </div>
              )}
            </div>
          </>
        )}
      </div>
      {!fullScreenView && selectedBy === 'IN' && (
        <div className='row mr-2'>
          <div className='col-sm-12'>
            <div className='text-right mt-2'>
              <Button
                className='btn btn-success btn-search'
                // data-testid="resume-btn"
                onClick={() => handleSearchByInvoiceNumber()}
                data-testid='check_search_cbi'
              >
                <SVGComponent iconName='Icon-search' /> {'  '}
                Search
              </Button>
            </div>
          </div>
        </div>
      )}
      {selectedBy === 'PQM' ? (
        <div className='panel tBillPanel-space pb-0'>
          <div className='FRR-custom-table tbl-manufacturer-home'>
            <TableGrid
              gridHeight={fullScreenView ? '100vh' : 350}
              gridCall={onGridReady}
              rowData={invoiceData || []}
              cellClickedListener={selectByInvoiceNumberClick}
              columnDefs={manuFactureHead}
              data-testid='onEditingStopped'
              enterMovesDown
              suppressCellFocus
              onCellFocused={onCellFocused}
              navigateToNextCell={navigateToNextCell}
              // tabToNextCell={tabToNextCell}
              fullScreenView={fullScreenView}
              handleFullScreenViewClick={handleFullScreenViewClick}
              exportFile
              fileName='Invoice Details'
              onSelect={(e) => {
                onSelectManufacturer(e);
              }}
            />
          </div>
          {showViewHistory ? (
            <ViewHistoryComponent
              setShowViewHistory={setShowViewHistory}
              tableName='invoice_details'
              keyValue={keyValue}
            />
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
export default withRouter(RequestInvoiceDetails);
